import { h } from '@stencil/core';

const InputField = ({ groupProps, inputProps, name, label, type, min = '', max = '', placeholder = '', validate = {}, locale = 'en-US', onBlur= () => null, readOnly = false, disabled = false, value = undefined, onInput = undefined, inputRef = undefined}) => {
  const { ref, unRef, ...restInputProps } = inputProps(name);

  const overrides = {}
  if (value) {
    overrides['value'] = value
  }
  if (onInput) {
    overrides['onInput'] = (value) => {
      onInput(value)
      restInputProps.onInput?.(value)
    }
  }
  if (inputRef) {
    overrides['inputRef'] = (el) => {
      inputRef(el)
      ref(el)
    }
  }

  return (
    <div {...groupProps(name)}>
      <rtr-input locale={locale} {...restInputProps}  type={type} {...validate} inputRef={ref} inputUnRef={unRef} label={label} min={min} max={max} placeholder={placeholder} onBlur={onBlur} readOnly={readOnly} disabled={disabled} {...overrides}/>
    </div>
  );
};

export default InputField;
